<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        订单跟踪
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto;border:1px solid rgba(221, 221, 221, 1);">
      <div class="center_list_head_left">
        <div>订单跟踪</div>
      </div>
      <div v-show="show11" class="filtrate_center" style="background:#fff;height:100%">
        <div style="display:flex">
          <div style="margin:30px 100px;">
            物流公司:
            <span style=" color: #f76f7d;">{{company}}</span>
          </div>
          <div style="margin:30px 30px; ">
            订单编号:
            <span style="color: #f76f7d;">{{no}}</span>
          </div>
        </div>
        <div style="margin:50px 50px;">
          <div class="block">
            <el-timeline>
              <el-timeline-item
                v-for="item in tabel"
                :key="item.index"
                :timestamp="item.datetime"
                placement="top"
              >
                <el-card>
                  <h4>{{item.remark}}</h4>
                  <!-- <p>王小虎 提交于 2018/4/12 20:46</p> -->
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
      <div
        v-show="show12"
        style="text-align: center;font-size: 24px;line-height: 50px;"
      >{{msg}}</div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "list",
  data() {
    return { serve: this.$store.state.serve,
      show11: true,
      show12: false,
      token: "",
      username: "",
      id: this.$route.params.id,
      company: "",
      no: "",
      tabel: [],
      radio: 1,
      msg:'',
    };
  },
  created() {
    
    this.$store.state.topActiveId = 3;
    this.$store.state.leftTitle = "订单列表";
    const _this = this;
    this.token = this.$cookies.get("token");
    this.username = this.$cookies.get("username");
    this.axios
      .get(this.serve+"/admin/order_tail", {
        params: {
          username: this.username,
          token: this.token,
          order_id: this.id
        }
      })
      .then(res => {
       
        var json = res.data.data;
        if (res.data.status == "success") {
          _this.company = json.express_com;
          _this.no = json.express_code;

          var tab = JSON.parse(json.list);

          for (var key in tab) {
            this.tabel.push(tab[key]);
          }
        } else if (res.data.status == "error") {
          this.show11 = false;
          this.show12 = true;
          this.msg = res.data.msg
        }
      });
  }
};
</script>
<style lang="scss">
.list {
  min-height: 1000px;
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }

  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .center_list_head_left {
    line-height: 46px;
    // padding-left: 12px;
    height: 46px;
    width: 100%;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    > div {
      margin-left: 10px;
    }
  }
  .step {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
}
</style>